module.exports = __webpack_public_path__ + "img/ft_soybean_meal.b9548ac3.jpg";